/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileCrossOut: {
  name: 'file-cross-out';
  data: string;
} = {
  name: 'file-cross-out',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 2a1 1 0 0 0 0 2h5v4a2 2 0 0 0 2 2h4v5a1 1 0 1 0 2 0V9.414c0-.081-.005-.162-.015-.242a1.004 1.004 0 0 0-.41-.99 2.004 2.004 0 0 0-.16-.182L14 2.586a1.986 1.986 0 0 0-.182-.161.999.999 0 0 0-.99-.41A2 2 0 0 0 12.586 2H7Zm7 3.414V8h2.586L14 5.414ZM6 9a1 1 0 0 0-2 0v11a2 2 0 0 0 2 2h11a1 1 0 1 0 0-2H6V9ZM3.293 3.293a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-16-16a1 1 0 0 1 0-1.414Zm6.414 10a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414-1.414l-2-2Z" fill="currentColor"/></svg>`,
};
